module.exports = __webpack_public_path__ + "img/foley-bus-lines.953c1bbe.webp";